import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ErrorSection = function ErrorSection(_ref) {
  var statusCode = _ref.statusCode;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var subtitle = t("errors.".concat(statusCode));
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Result, {
      status: statusCode,
      title: statusCode,
      subTitle: subtitle,
      extra: /*#__PURE__*/_jsxs(_Fragment, {
        children: [[500, '500'].includes(statusCode) && /*#__PURE__*/_jsx(Button, {
          type: "primary",
          onClick: function onClick() {
            return window.location.href = "".concat(window.location.href);
          },
          children: t('errors.reload')
        }), [403, 404, '403', '404'].includes(statusCode) && /*#__PURE__*/_jsx(Button, {
          type: "primary",
          onClick: function onClick() {
            return window.location.href = '/';
          },
          children: t('errors.goBack')
        })]
      })
    }), ","]
  });
}; // Styles

var Container = styled.div.withConfig({
  displayName: "ErrorSection__Container",
  componentId: "sc-eonext-0"
})(["display:flex;align-items:center;justify-content:center;height:100%;"]);